<div class="form-group video-overlay-one-form">
    <ano-input [config]="data" [isEditMode]="true"></ano-input>
    <div class="invalid-feedback"><ng-container *ngIf="error">{{'error.required' | localize}}</ng-container></div>
</div>
<div class="form-group text-center">
    <button class="btn btn-success btn-sm" (click)="answer()">{{'survey.button.vote' | localize}}</button>
</div>
